// src/components/Tutorial/Examples/VipCard.js
import React from 'react';
import { Card, CardContent, Typography, Box, Button, Stack, Chip, Avatar } from '@mui/material';
import { CardMembership as VipIcon, PersonOutline as PersonIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

export default function VipCard() {
  return (
    <Box className="example-container" sx={{ mt: 3 }}>
      <Card sx={{ 
        borderRadius: 3, 
        boxShadow: 2, 
        display: 'flex', 
        flexDirection: 'column',
      }}>
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <VipIcon sx={{ color: 'white', fontSize: 28 }} />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight={700}>
                Account Status
              </Typography>
            </Box>
          </Box>

          {/* Free Account State (what new users see) */}
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 2,
                boxShadow: '0 4px 20px rgba(245, 87, 108, 0.3)',
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                  opacity: 0.3,
                  animation: 'pulse 2s ease-in-out infinite',
                },
                '@keyframes pulse': {
                  '0%, 100%': {
                    transform: 'scale(1)',
                  },
                  '50%': {
                    transform: 'scale(1.1)',
                  },
                },
              }}
            >
              <PersonIcon sx={{ fontSize: 40, color: 'white', position: 'relative', zIndex: 1 }} />
            </Box>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom>
              Free Account
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Upgrade to VIP for exclusive features and benefits
            </Typography>
            <Button
              variant="contained"
              fullWidth
              sx={{
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                fontWeight: 600,
                '&:hover': {
                  background: 'linear-gradient(135deg, #f5576c 0%, #f093fb 100%)',
                },
              }}
            >
              Upgrade to VIP
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
